import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNrday80 } from './pages'

type TIdToPageMapWoofzNrday80 = Record<PageIdWoofzNrday80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NRDAY_80: TIdToPageMapWoofzNrday80 = {
  [PageId.SUBSCRIPTIONS_NRDAY_80_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/subscriptions/SubscriptionNrday80'
      ).then((m) => ({
        default: m.SubscriptionsNrday80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/subscriptions/SubscriptionNrday80'
      ),
  },
  [PageId.CHAT_UPSELL_NRDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NRDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzNrday80.DOWNLOAD_NRDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNrday80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
